import { render } from "../views/list-event.html?vue&type=template&id=5ff47f8d&ts=true&external"
import script from "../scripts/list-event.ts?vue&type=script&lang=ts&external"
export * from "../scripts/list-event.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/list-event.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/list-event.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ff47f8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ff47f8d', __exports__)) {
    api.reload('5ff47f8d', __exports__)
  }
  
  module.hot.accept("../views/list-event.html?vue&type=template&id=5ff47f8d&ts=true&external", () => {
    api.rerender('5ff47f8d', render)
  })

}


export default __exports__